import React from 'react';

const Terms = () => {
  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">Terms of Use</h1>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        By using <strong>SmartAuditx</strong>, you agree to comply with the following Terms of Use. These terms govern your access to and use of the platform. Please read them carefully before using the site.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Use of the Platform</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        SmartAuditx provides free access to audit resources, templates, toolkits, and other materials. You are free to browse, download, and use the materials available on the platform, as long as you agree to abide by these terms.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Prohibited Activities</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        When using SmartAuditx, you agree not to:
      </p>
      <ul className="list-disc pl-6 text-sm sm:text-base text-gray-600 mb-4">
        <li>Engage in illegal or unauthorized activities.</li>
        <li>Use the platform to distribute malicious software or harmful content.</li>
        <li>Impersonate any individual or entity, or misrepresent your affiliation with any person or organization.</li>
        <li>Attempt to gain unauthorized access to the platform or interfere with its normal operation.</li>
      </ul>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Intellectual Property</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        All content on SmartAuditx, including text, images, videos, logos, and other materials, are the intellectual property of SmartAuditx or its licensors and are protected by copyright laws. You may use these materials for personal, non-commercial purposes only, and you may not redistribute, modify, or use them for commercial purposes without prior consent.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Copyright for Reference Materials</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        Some of the reference materials available on SmartAuditx may be copyrighted by the original authors or organizations. The copyright for these materials is owned by the respective owners, as indicated in the documents themselves. You must respect the terms set forth in these documents and not use them for any purpose other than what is permitted by the original copyright holders.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Disclaimers</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        The content and resources provided on SmartAuditx are for general informational purposes only. We do not guarantee the accuracy, completeness, or reliability of any materials available on the platform. Your use of the materials is at your own risk.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Limitation of Liability</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        SmartAuditx and its affiliates will not be held responsible for any damages or losses arising from the use of or inability to use the platform, including but not limited to direct, indirect, incidental, or consequential damages.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Changes to the Terms</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        SmartAuditx reserves the right to update or modify these Terms of Use at any time. Any changes will be posted on this page with an updated revision date. It is your responsibility to review the Terms periodically to stay informed of any updates.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Contact Us</h2>
      <p className="text-sm sm:text-base text-gray-600">
        If you have any questions or concerns about these Terms of Use, please contact us at <a href="mailto:support@smartauditx.com" className="text-blue-500">support@smartauditx.com</a>.
      </p>
    </div>
  );
};

export default Terms;
